import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CFF782E5-F36B-4F80-B105-68E6B4B91C64
 * name keyboard-tab-reverse
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-tab-reverse.svg
 * tags
 */
export const KeyboardTabReverseIcon = createSvgIcon(<><path d="M4 6H2V18H4M11 6L5 12L11 18L12.41 16.58L8.83 13H23V11H8.83L12.41 7.41L11 6Z" /></>, 'KeyboardTabReverseIcon');
export default KeyboardTabReverseIcon